import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Button,
  ModalBody,
  Text,
} from "@chakra-ui/react";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedOption,
  tipo,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        my="auto"
        borderRadius={"3xl"}
        width={"100%"}
        minWidth={"25%"}
      >
        <ModalHeader></ModalHeader>

        {tipo === "guarda" ? (
          <ModalBody textAlign={"justify"}>
            <Text>
              <b>{selectedOption?.label ? selectedOption?.label : ""}</b>
            </Text>

            <Text as="p" mt={"1"}>
              {selectedOption?.descricao ? selectedOption?.descricao : ""}
            </Text>
          </ModalBody>
        ) : (
          <ModalBody textAlign={"justify"}>
            <Text>
              <b> Situação: </b>
              {selectedOption?.tipoSituacao?.descricao
                ? selectedOption?.tipoSituacao?.descricao
                : ""}
            </Text>
            <Text>
              <b> Motivo de Situação: </b>
              {selectedOption?.descricao ? selectedOption?.descricao : ""}
            </Text>
            <Text>
              <b> Conceito: </b>
              <Text as="span" mt={"1"}>
                {selectedOption?.conceito ? selectedOption?.conceito : ""}
              </Text>
            </Text>
          </ModalBody>
        )}

        <ModalFooter display={"flex"}>
          <Button
            type="button"
            onClick={onConfirm}
            color="#FFF"
            m={"auto"}
            backgroundColor="#169499"
            fontWeight={700}
            px={"10"}
            fontSize="15px"
            lineHeight="21.6px"
            _hover={{ bg: "#169499" }}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
